// Shared number formatting: thousands separators everywhere money is shown.
export const fmtNumber = (value, minDecimals = 0, maxDecimals = 2) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0';
  return n.toLocaleString('en-US', { minimumFractionDigits: minDecimals, maximumFractionDigits: Math.max(minDecimals, maxDecimals) });
};

// Fixed decimals, like toFixed() but with commas: fmtFixed(1234.5) -> "1,234.50"
export const fmtFixed = (value, decimals = 2) => fmtNumber(value, decimals, decimals);

export const fmtUsd = (value, decimals = 2) => {
  const n = Number(value) || 0;
  return `${n < 0 ? '-' : ''}$${fmtFixed(Math.abs(n), decimals)}`;
};

// Prices: 2 decimals above $1, more precision for tiny prices
export const fmtPrice = (value) => {
  const n = Number(value) || 0;
  if (n >= 1) return fmtFixed(n, 2);
  return fmtNumber(n, 4, n >= 0.01 ? 4 : 8);
};
